import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  justifyContent: 'center',
  gap: 24
});

export const buttonContainer = css({
  width: '320px'
});
